import reducer from './reducers';

export { default as settingsOperations } from './operations';
export { default as settingsTypes } from './types';
export { default as settingsActions } from './actions';

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/settings/index.js